import { createUseStyles } from 'react-jss'

import { darkGrey } from '../../../../../../styles/const/colors'

const scrollableColumn = {
  overflowY: 'auto',
  // Add spacing between content and scrollbar
  paddingRight: 12,
  // Custom scrollbar styling
  '&::-webkit-scrollbar': {
    width: 6
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: '#f1f1f1',
    borderRadius: 3
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#c1c1c1',
    borderRadius: 3
  },
  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: '#a8a8a8'
  }
}

const useStyles = createUseStyles({
  stakeholdersPanel: {
    padding: '70px 30px'
  },
  totalsColumn: {
    height: '100%'
  },
  stakeholdersColumn: {
    display: 'flex',
    flexDirection: 'column',
    alignSelf: 'flex-start',
    gap: 20,
    height: 200,
    ...scrollableColumn
  },

  stakeholdersColumnItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 8
  },
  stakeholderLabel: {
    fontSize: 14,
    fontWeight: 700,
    color: darkGrey
  },
  stakeholderValue: {
    fontSize: 24,
    fontWeight: 700,
    textAlign: 'right'
  }
})

export default useStyles
